<template>
    <!--Client Waiting List Page-->
    <div class="client-step2">
        <!--Step Two-->
        <div class="client-step2-wrap section-wrap">
            <!--Subtitle-->
            <h5>
                {{ $ml.get("waitingList.title") }} - {{ currentWaitingListStylist.first_name }},
                {{ currentWaitingListStylist.last_name }}
            </h5>

            <div class="step2-inner-wrap">
                <div class="steps">
                    <p class="highlight-text">{{ $ml.get("waitingListClient.stepOne") }}</p>
                    <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                </div>
                <div class="steps">
                    <p class="highlight-text">{{ $ml.get("waitingListClient.stepTwo") }}</p>
                </div>
                <div class="client-step2-wrap" v-if="!loading">
                    <p>
                        Please add me to {{ currentWaitingListStylist.first_name }}
                        {{ currentWaitingListStylist.last_name }}’s wait list and notify me if a spot becomes available
                        for the following service(s):
                    </p>
                    <div class="services-wrap">
                        <div class="service-inner-wrap">
                            <div class="select-service-wrap">
                                <select
                                    class="selectInput selectInputExtraSmall"
                                    v-model="selectedServiceId"
                                    @change="setSelectedService"
                                >
                                    <option disabled value="0">Services</option>
                                    <option v-for="service in onlyServices" :key="service.id" :value="service.id">
                                        {{ service.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="service-inner-wrap section-wrap" v-if="selectedServiceId > 0">
                            <p>{{ selectedService.name }}</p>
                            <div @click="removeSelectedService">
                                <i class="fa fa-times close-icon" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <p class="text-error" v-if="selectedServiceId == 0">
                        {{ $ml.get("waitingList.note") }} {{ $ml.get("waitingList.selectService") }}
                    </p>
                    <div class="next-btn">
                        <button
                            :disabled="selectedServiceId == 0"
                            type="button"
                            :class="selectedServiceId == 0 ? 'disabled-button' : ''"
                            class="primary-btn extra-small mobile"
                            @click="handleSaveClientWaitlistSettings"
                        >
                            {{ $ml.get("general.saveContinue") }}
                        </button>
                        <button type="button" class="secondary-btn small mobile" @click="changeSection('client-step1')">
                            {{ $ml.get("general.goBack") }}
                        </button>
                    </div>
                    <span class="main-text-link" @click="handleSaveForLater">{{ $ml.get("general.saveLater") }}</span>
                </div>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>
    </div>
</template>

<script>
import store from "../../../../../services/vuex";
import api from "../../../../../services/api_endpoints";
import MainLoader from "../../../general-components/main_loader.vue";
import messages from "../../../../../services/messages";
import { relativeTimeThreshold } from "moment";

export default {
    data() {
        return {
            selectedService: "",
            services: {},
            allServicesAndProducts: {},
            loading: false,
            selectedServiceId: 0,
            onlyServices: {},
        };
    },
    computed: {
        currentWaitingListStylist: {
            get: function () {
                return store.state.currentWaitingListStylist;
            },
            set: function (value) {
                store.commit("setCurrentWaitingListStylist", value);
            },
        },
    },
    mounted() {
        if (this.currentWaitingListStylist.id) {
            this.getStylistDetails(this.currentWaitingListStylist.id);
        }
    },
    components: { MainLoader },
    methods: {
        changeSection(section) {
            this.$emit("change-section", section);
        },
        getStylistDetails: function (id) {
            this.loading = true;
            this.$http.get(api.actions.get_stylist_details + id).then((response) => {
                if (response.data.error == true) {
                    return;
                }

                this.allServicesAndProducts = [];

                this.services = response.data.details.services;

                for (let category_id in this.services) {
                    this.allServicesAndProducts = [...this.allServicesAndProducts, ...this.services[category_id]];
                }

                this.onlyServices = this.allServicesAndProducts.filter((service) => {
                    return service.is_product === 0;
                });

                this.loading = false;
                this.getClientWaitlistSettings(this.currentWaitingListStylist.id);
            });
        },
        removeSelectedService() {
            this.selectedServiceId = 0;
        },
        setSelectedService() {
            this.allServicesAndProducts.forEach((service) => {
                if (this.selectedServiceId === service.id) {
                    return (this.selectedService = service);
                }
            });
        },
        handleSaveClientWaitlistSettings() {
            this.saveClientWaitlistSettings();
            this.changeSection("client-step3");
        },
        saveClientWaitlistSettings() {
            if (this.selectedServiceId == 0 || this.selectedServiceId == null) {
                return;
            }

            let data = {
                stylist_id: this.currentWaitingListStylist.id,
                service_ids: this.selectedServiceId,
            };

            this.$http.post(api.actions.save_client_waitlist_settings, data).then((response) => {
                if (response.data.error == true) {
                    return;
                }

                this.getClientWaitlistSettings(this.currentWaitingListStylist.id);

                messages.successMessage(messages.GLOBAL_MESSAGES.WAITING_LIST_SAVE_SERVICE);
            });
            return;
        },
        getClientWaitlistSettings(stylistId) {
            this.loading = true;

            this.$http.get(api.actions.get_client_waitlist_settings + "/" + stylistId).then(
                function (response) {
                    if (response.data.error == true) {
                        return;
                    }

                    if (response.data.settings.service_ids != null) {
                        for (let key in this.onlyServices) {
                            if (this.onlyServices[key].id === response.data.settings.service_ids[0]) {
                                this.selectedServiceId = response.data.settings.service_ids[0];
                            }
                        }

                        this.setSelectedService();
                    } else {
                        this.selectedServiceId = 0;
                        this.setSelectedService();
                    }

                    this.loading = false;
                }.bind(this)
            );
        },
        handleSaveForLater() {
            if (this.selectedServiceId == 0) {
                return;
            }

            this.saveClientWaitlistSettings();
            this.changeSection("client-wlist");
        },
    },
};
</script>
